<div *ngIf="documentType">
    <p-accordion>
        <p-accordionTab header={{getDocumentType()}}>
            <div *ngIf="documents.length > 0">
              <div *ngFor="let document of documents">
                <div class="border-round-sm document-section flex justify-content-start align-items-center" pRipple (click)="getOperationDocument(document.guid)">
                    <div class="dot flex justify-content-center align-items-center">
                      <span class="pi pi-file" style="color: white;"></span>
                    </div>
                    <span class="text-label" style="margin-left: 10px;">{{document.name}}</span>
                    <div style="flex: 1; text-align: right;">
                      <span class="text-label">{{ document.created | date:'dd-MM-yyyy HH:mm' }}</span>
                    </div>
                  </div>
              </div>
            </div>
        </p-accordionTab>
      </p-accordion>
</div>

